@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;

.totalTrackingApp {
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: v.$palette-white;
  height: 100%;
}

.mapWrapper {
  flex-grow: 1;
  display: flex;
  position: relative;
  background-color: v.$palette-gray-400;
}

.hiddenDetails {
  transform: translateX(-100%);
  width: 0;
  padding-left: 0;
  padding-right: 0;
}

.isToolsTabsVisibleInPanel {
  position: absolute;
  z-index: v.$z-index-map-tools;
  padding: 16px 16px 0;
  @include m.containerMedia(v.$desktop-tools-tabs-breakpoint, "min") {
    padding: 0;
  }
}

.isTabsVisible {
  @include m.containerMedia(v.$tablet-breakpoint) {
    padding-top: 44px;
  }
}

.isUpgradeButtonVisible {
  @include m.containerMedia(v.$js-defined-tablet-breakpoint) {
    padding-top: 44px;
  }
}

.mapTools {
  position: absolute;
  z-index: v.$z-index-map-tools;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  @include m.containerMedia(v.$js-defined-mobile-breakpoint) {
    top: 12px;
    right: 12px;
    gap: 6px;
  }
}

.upgradeBtnWrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.themeSwitcher {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
